import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { WIDTH_COLUMN, WIDTH_PERCENT_LEFT_HEADER } from '../../const';
import {
    HeaderType,
    ItemType,
    MappingItemIdHideCollapse,
    MappingItemIdIndexType,
    ModeTimeLineType,
    SavingScheduleItemsProcess,
    ScheduleItemType,
    SettingGantType,
} from '../../types';

export const getWidthLeftHeader = (availableWidth: number) => (availableWidth / 100) * WIDTH_PERCENT_LEFT_HEADER;

export interface IGantState {
    headerType: HeaderType;
    widthLeftHeader: number;
    widthColumn: number;
    modeTimeLine: ModeTimeLineType;
    currentOffsetDate: string;
    calendarOffsetDays: number;
    startDate: string;
    endDate: string;
    startDateExtend: string;
    endDateExtend: string;
    availableWidth: number;
    availableHeight: number;
    mappingInputItemIdIndex: MappingItemIdIndexType;
    mappingItemIdIndex: MappingItemIdIndexType;
    mappingItemIdHideCollapse: MappingItemIdHideCollapse;
    pixelOffsetVertical: number;
    connectionItemsId: string;
    connectionSettingGant: string;
    savingProcess: SavingScheduleItemsProcess;
    newExternalItem: ScheduleItemType | null;
    appendExternalItem: ScheduleItemType | null;
    expandItemIds: string | null;
    settingGant: SettingGantType | null;
    authorId: string;
    dayForListTaskShow: string[];
    scheduleItemForListTaskShow: ItemType | null;
    dragBond: ItemType | null;
    dropBond: ItemType | null;
    countVisibleRow: number;
    paddingBottom: number;
    availableHeightTable: number;
}

const initialState: IGantState = {
    headerType: 'day',
    widthLeftHeader: getWidthLeftHeader(window.innerWidth),
    widthColumn: WIDTH_COLUMN,
    modeTimeLine: 'timeline',
    currentOffsetDate: '',
    calendarOffsetDays: 0,
    startDate: '',
    endDate: '',
    startDateExtend: '',
    endDateExtend: '',
    availableWidth: window.innerWidth,
    availableHeight: window.innerHeight,
    availableHeightTable: window.innerHeight,
    mappingInputItemIdIndex: {},
    mappingItemIdIndex: {},
    mappingItemIdHideCollapse: {},
    pixelOffsetVertical: 0,
    connectionItemsId: '',
    connectionSettingGant: '',
    savingProcess: 'none',
    newExternalItem: null,
    appendExternalItem: null,
    expandItemIds: null,
    settingGant: null,
    authorId: '',
    dayForListTaskShow: [],
    scheduleItemForListTaskShow: null,
    dragBond: null,
    dropBond: null,
    countVisibleRow: 0,
    paddingBottom: 0,
};

export const gantSlice = createSlice({
    name: 'gant',
    initialState,
    reducers: {
        setterGant: (state, action: PayloadAction<Partial<IGantState>>) => {
            return {
                ...state,
                ...action.payload,
            };
        },
        setMappingItemIdIndex: (state, action: PayloadAction<MappingItemIdIndexType>) => {
            console.log('===>>', Object.keys(action.payload).length, action.payload);
            return {
                ...state,
                mappingItemIdIndex: action.payload,
            };
        },
    },
});

export const { setterGant, setMappingItemIdIndex } = gantSlice.actions;

export default gantSlice.reducer;
